export default "__VITE_ASSET__1YyRhVwA__"